export default "__VITE_ASSET__BKfGddUP__"